<template>
    <div class="form2">
       
        <div class="content1">
            <ul>
                <li>
                    <span>姓名</span>
                    <p>{{NAME}}</p>
                </li>
                <li>
                    <span>性别</span>
                    <p>{{GENDER}}</p>
                </li>
                <li>
                    <span>联系电话</span>
                    <p>{{PHONE_NUM}}</p>
                </li>
                <li>
                    <span>证件类型</span>
                    <p>{{CARD_TYPE}}</p>
                </li>
                <li>
                    <span>证件号码</span>
                    <p>{{ID_CARD}}</p>
                </li>
                <li>
                    <span>文化程度</span>
                    <p>{{EDUCATION}}</p>
                </li>
                <li>
                    <span>职业</span>
                    <p>{{JOB}}</p>
                </li>
                <li>
                    <span>关系</span>
                    <p>本人</p>
                </li>
            </ul>
        </div>
        <router-link to="/user/updatePersonInfo">
            <div class="btn">
                <button type="button" class="btnstyle">修改信息</button>
            </div>
        </router-link>
    </div>
</template>
<script>
    import api from "@/fetch/api";
     import {
        mapGetters,
        mapActions
    } from 'vuex';
    export default {
        data() {
            return {
                NAME: '',
                GENDER: '',
                PHONE_NUM: '',
                JOB: '',
                ID_CARD: '',
                CARD_TYPE: '',
                EDUCATION: '',

            }
        },
        created() {
            this.setBasicData();
            api.getCustomerInfo(this.userInfo.CUSTOMER_ID,this.userInfo.CUSTOMER_ID,this.userInfo.TOKEN).then(re => {
                // console.log(re.data);
                let data = re.data;
                this.NAME = data.NAME;
                // this.GENDER = data.GENDER;
                this.PHONE_NUM = data.PHONE_NUM;
                this.JOB = data.JOB;
                this.ID_CARD = data.ID_CARD;
               

                  this.GENDER=this.sexes.find(p=>p.key==data.GENDER).value;
                this.EDUCATION =this.educations.find(p=>p.key==data.EDUCATION).value; 
                this.CARD_TYPE =this.cardTypes.find(p=>p.key==data.CARD_TYPE).value; 

                // this.DICS.OCCUPTS=data.occupationlist;
                this.JOB = this.occupations.find(p=>p.key==data.JOB).value; 
            })
        },
       
        methods: {
             ...mapActions(["setBasicData"])
           
        },
        computed: {
            ...mapGetters(["loginStatus", "userInfo","occupations","relations","sexes","cardTypes","educations"]),
        }
    }
</script>
<style lang="less">
    .form2 {
        .btn {
            margin: 4em 0 0 0;
            padding: 0;
            text-align: center;
            .btnstyle {
                width: 80%;
                height: 38px;
                background-color: #aacd06;
                border: none;
                border-radius: 5px;
                color: #FFF;
                text-align: center;
            }
        }
        .content1 {
            font-family: 'Arial Normal', 'Arial';
            font-weight: 400;
            font-style: normal;
            line-height: normal;
            font-size: 14px;
            li {
                position: relative;
                padding: 0.5em 0em 0.5em 6em;
                margin-bottom: 10px;
                height: 2em;
                span {
                    display: block;
                    width: 5em;
                    position: absolute;
                    left: 1.5em;
                    top: 0.5em;
                    height: 2em;
                }
                p {
                    text-align: center;
                    width: 90%;
                    color: #AEAEAE;
                    width: 90%;
                    height: 2em;
                    margin: 0;
                }
            }
        }
        .top1 {
            font-family: 'Arial Normal', 'Arial';
            font-weight: 400;
            font-style: normal;
            line-height: normal;
            font-size: 14px;
            margin-bottom: 10px;
            .ts {
                background-color: rgba(233, 248, 248, 1);
                padding: 10px 5px 10px 5px;
                .s1 {
                    color: #ff9966;
                }
                .s2 {
                    color: #C9C9C9;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/personInfo.vue